import Input from "components/FormElements/Input/Input";
import { usePinLogin } from "hooks/usePinLogin";
import { useEffect, useRef, useState } from "react";
import "./EnterPIN.scss";

const EnterPIN = () => {
  const { loginWithPin, error } = usePinLogin();
  const [pin, setPin] = useState("");
  const [isLocked, setIsLocked] = useState(false);
  const inputRef = useRef(null);

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  useEffect(() => {
    if (pin.length !== 4 || isLocked) return;
    const submitPin = async () => {
      const result = await loginWithPin(pin);
      if (!result.success) {
        setPin("");
        if (result.locked) setIsLocked(true);
      }
    };
    submitPin();
  }, [pin, loginWithPin, isLocked]);

  const handleChange = (event) => {
    if (isLocked) return;
    const value = event.target.value.replace(/\D/g, "").slice(0, 4);
    setPin(value);
  };

  return (
    <div className="enter-pin" onClick={() => inputRef.current?.focus()}>
      <Input
        inputClassName="enter-pin__hidden-input"
        ref={inputRef}
        type="text"
        inputMode="numeric"
        maxLength={4}
        value={pin}
        onChange={handleChange}
        autoComplete="off"
        disabled={isLocked}
      />
      <div className="enter-pin__dots">
        {[0, 1, 2, 3].map((index) => (
          <div key={index} className={index < pin.length ? "enter-pin__dot enter-pin__dot--filled" : "enter-pin__dot"}><span></span></div>
        ))}
      </div>
      {error && !isLocked && <div className="enter-pin__error"> {error} </div>}
      {isLocked && <div className="enter-pin__error"> Try again in 15 minutes. </div>}
    </div>
  );
};

export default EnterPIN;